import {TOGGLE} from '@drivesally/sally-fw/lib/inputTypes';

// Attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

export default attribute({
  type: TOGGLE,
  attribute: 'requires_rental_insurance_id',
  label: {
    default: 'Requires Rental Insurance ID',
    short: 'Rental Insurance ID',
  },
});
